// utils/StatusColor.js

const statusColorScheme = {
  "Pending": "yellow",
  "In Transit": "blue", 
  "Delivered": "green",
  "Canceled": "red",
  "Awaiting Pick Up": "purple", // Fixed typo from "purble"
  "Picked Up": "teal"
};
  

  const getStatusColor = (status) => {
    return statusColorScheme[status] || "gray";
  };
  
  export default getStatusColor;
  